/**
 * Cascade animation utility
 * 
 * Mark elements with data-cascade-index="N" (0-based) to participate.
 * CSS on [data-cascade-index] should define the hidden state.
 * CSS on [data-cascade-index].cascade-visible should define the visible state + transition.
 * 
 * @param {Element} container - Parent element to search within
 * @param {number} delay - Milliseconds between each item fading in (default: 60)
 */

function cascadeIn(container, delay = 80) {
  container.querySelectorAll('[data-cascade-index]').forEach(el => {
    const i = +(el.dataset.cascadeIndex);
    setTimeout(() => el.classList.add('cascade-visible'), i * delay);
  });
}

function cascadeOut(container) {
  container.querySelectorAll('[data-cascade-index]').forEach(el => {
    el.classList.remove('cascade-visible');
  });
}